export const MODULE_PERMISSION_ENUM = {
  ALL_MODULES: "ALL_MODULES",

  // My Business
  MY_BUSINESS: "MY_BUSINESS",
  CREATE_PO: "CREATE_PO",
  PURCHASE_ORDER: "PURCHASE_ORDER",
  DISPATCH_PLAN: "DISPATCH_PLAN",
  SECONDARY_ORDER: "SECONDARY_ORDER",
  INVENTORY: "INVENTORY",
  INVOICE: "INVOICE",
  PERFORMANCE: "PERFORMANCE",
  PAYMENT: "PAYMENT",

  // My Benefits
  MY_BENEFITS: "MY_BENEFITS",
  BENEFICIARY: "BENEFICIARY",
  CUMULATIVE_TDS: "CUMULATIVE_TDS",
  CUMULATIVE_GAP: "CUMULATIVE_GAP",
  MY_REWARDS: "MY_REWARDS",
  NETWORK_REWARDS: "NETWORK_REWARDS",

  // My Network
  ONBOARD_BUYER: "ONBOARD_BUYER",
  MY_NETWORK: "MY_NETWORK",

  // Analytics
  PERFORMANCE: "PERFORMANCE",
  NETWORK_PERFORMANCE: "NETWORK_PERFORMANCE",
  FAQ: "FAQ",

  // Frontend side key
  HOME: "HOME",

  // My Account
  FIRMS: "FIRMS",
  PROFILER: "PROFILER",
  ADDRESS: "ADDRESS",
  STAFF: "STAFF",
};